module.exports = __webpack_public_path__ + "img/qingdao_shili_xi.a9abda37.png";